'use strict'

module.exports = function count (max) {
  var i = 0; max = max || Infinity
  return function (end, cb) {
    if(end) return cb && cb(end)
    if(i > max)
      return cb(true)
    cb(null, i++)
  }
}





//////////////////
// WEBPACK FOOTER
// ./node_modules/pull-stream/sources/count.js
// module id = k7W9
// module chunks = 0